var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name == 'RegisterEvent' || _vm.$route.name == 'UnPaidRegistration')?_c('RegistrationMenu',{on:{"changeDMenu":function($event){return _vm.$emit('changeDMenu')},"loadOptionsRegistration":_vm.loadOptionsRegistration}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }